import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}

// Each tone is a text shade on its own tint, both checked for AA contrast (see index.css).
const toneStyles: Record<BadgeTone, string> = {
  neutral: 'bg-neutral-tint text-neutral',
  success: 'bg-ok-tint text-ok',
  warning: 'bg-wait-tint text-wait',
  danger: 'bg-bad-tint text-bad',
  info: 'bg-brand-tint text-brand-ink',
};

export const Badge = ({ children, tone = 'neutral', className }: BadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-2.5 py-0.5 text-micro font-medium rounded-full whitespace-nowrap',
      toneStyles[tone],
      className
    )}
  >
    {children}
  </span>
);

/** The status badge used everywhere: Approved, Waiting, Rejected, Confirmed, Unmatched ... */
export const StatusPill = Badge;
